module.exports = __webpack_public_path__ + "img/img8.1278dac8.png";